
import Table from './Table';
import ActivityCard from '../../../../Core/Activity/ActivityCard';
const Tab2 = ({ setSelectedtax, selectedTaxAccounts, taxId }) => {
  return (
    <div>
      <div
        className="row mb-3"
        style={{ border: "1px solid rgba(50, 50, 50, 0.35)", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Tax Rates</p>
          <Table
            setSelectedtax={setSelectedtax} selectedTaxAccounts={selectedTaxAccounts}
          />
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Item Tax Template" docname={taxId} />
      </div>
    </div>
  )
}

export default Tab2